module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"404":"404 Pagina non trovata"},"en":{"404":"404 Page not found"}}')
  delete Component.options._Ctor
}
